export default __webpack_public_path__ + "static/media/nft-life.7855168e.jpg";